import { _ as _getNative } from './_getNative.mjs';
import { _ as _root } from './_root.mjs';

var getNative = _getNative,
    root = _root;

/* Built-in method references that are verified to be native. */
var Promise$1 = getNative(root, 'Promise');

var _Promise = Promise$1;

export { _Promise as _ };
